import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DownloadIcon, IconCTA, OverlayTriggerTooltip } from '@utilities';
import { fastTrackStatus, setEndpoint } from '@helpers';

import styles from './_index.module.scss';

export const FlowDownload = ({ hasException, isHoverAction, selectedRows }) => {
  const flows = useSelector((state) => state?.websocket?.flows);
  const flow = flows?.find((flow) => flow?.id === selectedRows[0]?.id);

  const isAvailable = selectedRows[0]?.isCompleted || flow?.status === fastTrackStatus.COMPLETED;

  const isVisible = selectedRows.length === 1 && !hasException;
  const downloadFileUrl = setEndpoint(`api/flows/${selectedRows[0]?.id}/export`);

  if (!isVisible) return null;

  const overlayContent = isAvailable
    ? 'Download as .XLSX file'
    : 'Download will be available after flow has finished processing';

  return (
    <OverlayTriggerTooltip
      aria-label="Download"
      content={overlayContent}
      placement={!isHoverAction ? 'top' : undefined}
    >
      <div className={classNames(styles['download'], { [styles['is-disabled']]: !isAvailable })}>
        <IconCTA
          data-testid="download-cta"
          href={downloadFileUrl}
          icon={<DownloadIcon />}
          text={isHoverAction ? '' : 'Download'}
        />
      </div>
    </OverlayTriggerTooltip>
  );
};

FlowDownload.propTypes = {
  hasException: PropTypes.bool,
  isHoverAction: PropTypes.bool,
  selectedRows: PropTypes.array,
};

export default FlowDownload;
